import { useQuery } from '@tanstack/react-query'
import { business } from '@chilipiper/service'
import { captureException } from '@chilipiper/sentry'
import { useEffect } from 'react'

export const useGetOrganizationName = (domain: string) => {
  const {
    data: name,
    isError,
    error,
  } = useQuery({
    queryKey: ['OrganizationName'],
    queryFn: () => business.domain.getOrganizationName(domain),
    refetchOnWindowFocus: false,
    enabled: domain !== '',
  })

  useEffect(() => {
    if (isError) {
      console.error(error)
      captureException(error)
    }
  }, [isError, error])

  return {
    name,
  }
}
